import { render, staticRenderFns } from "./simple-preference-element.vue?vue&type=template&id=d5934db8"
import script from "./simple-preference-element.vue?vue&type=script&lang=js"
export * from "./simple-preference-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports